import * as React from 'react';
import Box from '@mui/material/Box';
import CustomTabs from '../../components/CustomTabs';
import CorporateDocs from './CorporateDocs';
import { useTheme } from '@mui/material';

export default function DocTabs({ categories }) {
    const [value, setValue] = React.useState(categories[0]);

    const theme = useTheme();

    const handleChange = (event, newValue) => {
        setValue(categories.find((item) => item.value === newValue));
    };

    React.useEffect(() => {
        setValue(categories[0]);
    }, [categories]);

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <CustomTabs selectedValue={value.value} onSelectedValueChange={handleChange} tabList={categories} variant="scrollable" />
            </Box>
            {value?.files?.length > 0 && <CorporateDocs files={value?.files} />}
        </>
    );
}
